import Form from './form.vue';
import FormItem from './form-item.vue';

Form.FormItem = FormItem;

export default Form;
